import React, { useState, useEffect } from "react";
import { READ_ONLY_HINT } from "../../services/permissions";

// Click-to-edit table cell. onSave(field, oldValue, newValue) fires on
// Enter/blur only when the value actually changed; Escape reverts.
// readOnly renders the same value as plain text - no pointer, no hover, no
// way in - so a dispatcher reading a run sheet is never invited to type into
// a cell the server would refuse to save.
// `render` draws the value in display mode (e.g. one line per product);
// `title` overrides the hover text so a long cell can be read in full.
export default function EditableCell({ value, field, onSave, className, readOnly, render, title }) {
  const [isEditing, setIsEditing] = useState(false);
  const [val, setVal] = useState(value);

  useEffect(() => { setVal(value); }, [value]);

  const shown = render ? render(value) : value;

  if (readOnly) {
    return <td className={className} title={title || READ_ONLY_HINT}>{shown}</td>;
  }

  if (isEditing) {
    return (
      <td className={className}>
        <input
          autoFocus
          className="w-full bg-slate-900 border border-blue-500 rounded px-2 py-1 text-white outline-none"
          value={val ?? ""}
          onChange={(e) => setVal(e.target.value)}
          onBlur={() => {
            setIsEditing(false);
            if (val !== value) onSave(field, value, val);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setIsEditing(false);
              if (val !== value) onSave(field, value, val);
            } else if (e.key === "Escape") {
              setIsEditing(false);
              setVal(value);
            }
          }}
        />
      </td>
    );
  }

  return (
    <td
      className={`cursor-pointer hover:bg-slate-700/50 ${className}`}
      onClick={() => setIsEditing(true)}
      title={title || "Click to edit and train AI"}
    >
      {shown}
    </td>
  );
}
